import * as Yup from "yup";

export const incidentListValidator = () => {
  return Yup.object({
    facilityIds: Yup.array()
      .of(Yup.string().required("Facility is required"))
      .min(1, "At least one facility is required"),
    incidentTypes: Yup.array()
      .of(Yup.string().required("Incident Type is required"))
      .min(1, "At least one incident type is required"),
    startDate: Yup.string().required("Start Date is required"),
    endDate: Yup.string().required("End Date is required"),
  });
};

export const incidentTrendValidator = () => {
  return Yup.object({
    facilityIds: Yup.string().required("Facility is required"),
    startDate: Yup.string().required("Start Date is required"),
    endDate: Yup.string().required("End Date is required"),
  });
};

export const statusReportValidator = () => {
  return Yup.object({
    facilityIds: Yup.array()
      .of(Yup.string().required("Facility is required"))
      .min(1, "At least one facility is required"),
    startDate: Yup.string().required("Start Date is required"),
    endDate: Yup.string().required("End Date is required"),
  });
};

export const repeatIncidentValidator = () => {
  return Yup.object({
    facilityIds: Yup.array()
      .of(Yup.string().required("Facility is required"))
      .min(1, "At least one facility is required"),
    incidentTypes: Yup.array()
      .of(Yup.string().required("Incident Type is required"))
      .min(1, "At least one incident type is required"),
    residentStatus: Yup.array()
      .of(Yup.string().required("Resident status is required"))
      .min(1, "At least one resident status must be selected"),
    startDate: Yup.string().required("Start Date is required"),
    endDate: Yup.string().required("End Date is required"),
  });
};

export const woundAnalysisValidator = () => {
  return Yup.object({
    facilityIds: Yup.array()
      .of(Yup.string().required("Facility is required"))
      .min(1, "At least one facility is required"),
    skinIssueTypes: Yup.array()
      .of(Yup.string().required("Skin Issue Type is required"))
      .min(1, "At least one skin issue type is required"),
    startDate: Yup.string().required("Start Date is required"),
    endDate: Yup.string().required("End Date is required"),
  });
};

export const behaviorAnalysisValidator = () => {
  return Yup.object({
    facilityIds: Yup.string().required("Please select a facility"),
    startDate: Yup.string().required("Start date is required"),
    endDate: Yup.string().required("End date is required"),
    behaviorIncidentTypes: Yup.array()
      .min(1, "Please select at least one incident type")
      .required("Incident types are required"),
    behaviorIncidentSubTypes: Yup.array()
      .min(1, "Please select at least one incident sub type")
      .required("Incident sub types are required"),
  });
};

export const incidentRateValidator = () => {
  return Yup.object({
    facilityIds: Yup.array()
      .of(Yup.string().required("Facility is required"))
      .min(1, "At least one facility is required"),
    incidentTypes: Yup.array()
      .of(Yup.string().required("Incident Type is required"))
      .min(1, "At least one incident type is required"),
    residentStatus: Yup.array()
      .of(Yup.string().required("Resident status is required"))
      .min(1, "At least one resident status must be selected"),
    startDate: Yup.string().required("Start Date is required"),
    endDate: Yup.string().required("End Date is required"),
  });
};

export const injuryReportValidator = () => {
  return Yup.object({
    facilityIds: Yup.array()
      .of(Yup.string().required("Facility is required"))
      .min(1, "At least one facility is required"),
    incidentTypes: Yup.array()
      .of(Yup.string().required("Incident Type is required"))
      .min(1, "At least one incident type is required"),
    injuryTypes: Yup.array()
      .of(Yup.string().required("Injury Type is required"))
      .min(1, "At least one injury type is required"),
    startDate: Yup.string().required("Start Date is required"),
    endDate: Yup.string().required("End Date is required"),
  });
};
